import React from 'react';
import { Typography } from '@mui/material';

interface ContentProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  actions?: React.ReactNode;
  prop?: any;
  children: React.ReactNode;
}

const Content: React.FC<ContentProps> = ({ header, footer, actions, prop, children }) => {
  return (
    <>
      <div className={`boxform ${prop?.noBorder} ${prop?.noMargin} ${prop?.noPadding}`}>
        {header && <div className='boxheader'>
          <Typography variant='h4' component='h1' gutterBottom>
            {header}
          </Typography>
          {actions}
        </div>}
        <div className='boxfields'>
          {children}
        </div>
      </div>
      {footer && <div className="boxfooter">
        <div className='actions'>
          {footer}
        </div>
      </div>}
    </>
  );
};

export default Content;
